// @flow

import React from 'react';
import bemify from 'bemify-js';

import AccountMenuContainer from 'app/viewport/components/AccountMenuContainer';
import NotificationsMenuContainer from 'app/viewport/components/NotificationsMenuContainer';
import 'app/viewport/components/Header/HeaderAccountActions.scss';

import type { Node } from 'react';

import type { KindType } from 'app/common/types';

const bem = bemify('header-account-actions');

export const HeaderBlockAccountActions = ({
  kind,
  children,
}: {
  kind?: KindType,
  children: Node,
}) => <div className={bem(kind)}>{children}</div>;

type Props = {
  kind?: KindType,
};

const HeaderAccountActions = ({ kind }: Props) => (
  <HeaderBlockAccountActions kind={kind}>
    <AccountMenuContainer className={bem('__account-menu-container')} />
    <NotificationsMenuContainer
      className={bem('__notification-menu-container')}
    />
  </HeaderBlockAccountActions>
);

export default HeaderAccountActions;
